require('./angular-masonry');
module.exports = 'ngMasonry';


//////////////////
// WEBPACK FOOTER
// ./~/ng-masonry/index.js
// module id = 362
// module chunks = 2